import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { ElementRef, Input, OnInit, SimpleChanges } from '@angular/core';

import { SessionService } from 'src/app/session-service.service';
import { Directive } from '@angular/core';

@Directive({
  selector: '[appConfigSettingsInput]'
})
export class ConfigSettingsDirective implements OnInit {

  FontTypeEnum = FontTypeEnum;
  constructor(private elementRef: ElementRef, private sessionService: SessionService) {
  }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.color = this.sessionService.getConfigSettingsDto().inputColor;
    this.elementRef.nativeElement.style.fontFamily = FontTypeEnum[this.sessionService.getConfigSettingsDto().fontType] || FontTypeEnum.Sun;
    this.elementRef.nativeElement.style.fontSize = this.sessionService.getConfigSettingsDto().fontSizeParagraph + 'px';
  }
}
